module.exports = "publish-lights-yellow"